import React, { useState, useEffect } from 'react';
import {
  Box, Typography, TextField, Button, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const initialForm = { cargo: '', caracteristicas: '' };

const CreacionCargo = () => {
  const [form, setForm] = useState(initialForm);
  const [cargos, setCargos] = useState([]);
  const [editId, setEditId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchCargos();
  }, []);

  const fetchCargos = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/cargos', {
        credentials: 'include',
        headers: { 'x-access-token': token },
      });
      const data = await res.json();
      if (Array.isArray(data)) {
        setCargos(data);
      } else {
        setCargos([]);
      }
    } catch {
      setCargos([]);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.cargo.trim() || !form.caracteristicas.trim()) {
      setError('Ambos campos son obligatorios');
      return;
    }
    const token = localStorage.getItem('token');
    try {
      const url    = editId ? `/api/cargos/${editId}` : '/api/cargos';
      const method = editId ? 'PUT' : 'POST';
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'x-access-token': token },
        credentials: 'include',
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok) {
        setForm(initialForm);
        setEditId(null);
        fetchCargos();
      } else {
        setError(data.message || 'Error al guardar');
      }
    } catch {
      setError('Error de conexión');
    }
  };

  const handleEdit = (item) => {
    setForm({ cargo: item.cargo, caracteristicas: item.caracteristicas });
    setEditId(item._id);
    setError('');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCancelEdit = () => {
    setForm(initialForm);
    setEditId(null);
    setError('');
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const handleDelete = async () => {
    const token = localStorage.getItem('token');
    try {
      await fetch(`/api/cargos/${deleteId}`, {
        method: 'DELETE',
        headers: { 'x-access-token': token },
        credentials: 'include',
      });
      setOpenDialog(false);
      setDeleteId(null);
      fetchCargos();
    } catch {
      setOpenDialog(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, px: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
        Creación de Cargo
      </Typography>

      {/* Formulario */}
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {editId ? 'Editar Cargo' : 'Nuevo Cargo'}
        </Typography>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Cargo"
            name="cargo"
            value={form.cargo}
            onChange={handleChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Características"
            name="caracteristicas"
            value={form.caracteristicas}
            onChange={handleChange}
            fullWidth
            multiline
            minRows={3}
            sx={{ mb: 2 }}
          />
          {error && (
            <Typography color="error" variant="body2" sx={{ mb: 1 }}>
              {error}
            </Typography>
          )}
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button type="submit" variant="contained">
              {editId ? 'Actualizar' : 'Guardar'}
            </Button>
            {editId && (
              <Button variant="outlined" onClick={handleCancelEdit}>
                Cancelar
              </Button>
            )}
          </Box>
        </Box>
      </Paper>

      {/* Tabla */}
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Cargo</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Características</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700 }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cargos.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ color: '#888' }}>
                  No hay cargos registrados
                </TableCell>
              </TableRow>
            ) : (
              cargos.map((item) => (
                <TableRow key={item._id} hover>
                  <TableCell>{item.cargo}</TableCell>
                  <TableCell>{item.caracteristicas}</TableCell>
                  <TableCell align="center">
                    <IconButton size="small" onClick={() => handleEdit(item)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" color="error" onClick={() => confirmDelete(item._id)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Diálogo confirmar eliminación */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <Typography>¿Estás seguro de que deseas eliminar este cargo?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CreacionCargo;
